import { all } from "redux-saga/effects";

import authenticationWatcher from "./auth/authentication";
import userProfileWatcher from "./profile/myProfile";
import transactionsWatcher from "./profile/transactions";
import resetPasswordWatcher from "./auth/resetPassword";
import casinoLobbyWatcher from "./casino/lobby/casinoLobby";
import casinoGamesWatcher from "./casino/lobby/casinoGames";
import cmsWatcher from "./cms";
import walletWatcher from "../saga/profile/wallet";
import paymentWatcher from "./payment";
import bonusWatcher from "./casino/lobby/bonus";
import faqWatcher from "./Faq";
// import cointbetFriendsWatcher from "./cointbetFriends";
import favoritesWatcher from "./casino/lobby/favorites";
import supportWatcher from "./support/chatsupport";
import pusherWatcher from "./support/pusher";
import { sportbookNodeWatchers } from "../../sportbookNode-saga/saga";
import settingsWatcher from "./settings";
import sportsBannerWatcher from "./sportsBanner";
import fifaWatcher from "./fifa";
import notificationsWatcher from "./notifications/notifications";
import notificationSocketWatcher from "./notifications/notificationSocket";

export default function* rootSaga() {
  yield all([
    authenticationWatcher(),
    userProfileWatcher(),
    transactionsWatcher(),
    paymentWatcher(),
    resetPasswordWatcher(),
    casinoLobbyWatcher(),
    casinoGamesWatcher(),
    cmsWatcher(),
    walletWatcher(),
    bonusWatcher(),
    faqWatcher(),
    // cointbetFriendsWatcher(),
    favoritesWatcher(),
    supportWatcher(),
    pusherWatcher(),
    ...sportbookNodeWatchers.map((watcherFunc) => watcherFunc),
    settingsWatcher(),
    sportsBannerWatcher(),
    fifaWatcher(),
    notificationsWatcher(),
    notificationSocketWatcher(),
  ]);
}
